// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-container[data-v-5c6101e4] {\n  max-width: 500px;\n  background: white;\n  border-radius: 10px;\n  padding: 35px 30px;\n}\n.form-heading[data-v-5c6101e4] {\n  color: #151515;\n  font-size: 1.2rem !important;\n}\n.auth-outer-container[data-v-5c6101e4] {\n  background-color: var(--gray-bg);\n  min-height: 100vh;\n  overflow: auto;\n}\n#authView[data-v-5c6101e4] {\n  color: #151515 !important;\n}\n", ""]);
// Exports
module.exports = exports;
